/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Remove_Participation_ErrorInputs */

const en_remove_participation_error = /** @type {(inputs: Remove_Participation_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error: participation could not be removed`)
};

const de_remove_participation_error = /** @type {(inputs: Remove_Participation_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler: Teilnahme konnte nicht entfernt werden`)
};

/**
* | output |
* | --- |
* | "Error: participation could not be removed" |
*
* @param {Remove_Participation_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const remove_participation_error = /** @type {((inputs?: Remove_Participation_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Remove_Participation_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_remove_participation_error(inputs)
	return en_remove_participation_error(inputs)
});